import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { showWarnPopup } from './actions';

import style from './style.module.scss';

const WarnUserButton = ({
  userId,
  title,
  className,
  children,
  showWarnPopupAction,
}) => {
  const clickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    showWarnPopupAction(userId);
  };

  return (
    <button
      type="button"
      className={classnames(style.btn, className)}
      title={title}
      onClick={clickHandler}
    >
      {children}
    </button>
  );
};


export default connect(null, { showWarnPopupAction: showWarnPopup })(WarnUserButton);
